<template>
	<div class="odd-pop-block pb-5">

		<div class="row">

			<betStats :matchId="matchId" />

			<div class="odd-loading text-center" v-if="loading">
				<spinalLoader></spinalLoader>
			</div>
			<div class="matchNotfound alert alert-danger mx-2" v-if="matchNotfound && !loading">
				{{ t.fixture.odd_notfound }}
			</div>
		</div>
		<div class="row mb-2">
      <div class="col-6">
        <select class="form-control form-control-sm rounded w150 pull-left" v-model="liveOdds">
          <option value="false" selected>Pre Odds</option>
          <option value="true">Live Odds</option>
        </select>
      </div>
			<div class="col-6">
				<a @click="subMatchOdds()" href="javascript:;" class="btn btn-outline-primary pull-right">
					Refresh all
				</a>
			</div>
		</div>

		<oddHeader v-on:selected="filterMarket" v-if="oddHeader" :odds="odds" />
		<div class="b-t" v-for="odd in odds " v-if="checkFilteredMarket(marketType, odd.markets )">

			<template v-if="odd.layout > 14">
				<div class="market-item market-header b-r">
					<div class="market-wrapper">
						{{odd.name}}
					</div>
					<div class="odd-labels">
						<div v-for="selection in odd.odd" class="text-center">
							<span class="outcome px-2">{{ selection.outcome }}</span>
						</div>
					</div>
				</div>
				<div class="market-item b-t b-r">
					<div class="market-wrapper b-r">

					</div>
					<div class="odd-labels">
						<div v-for="selection in odd.odd" class="b-r text-center">
							<a :id="'_odd_'" href="#" :class="(findByKey(selectedOdds, 'oddId', selection.id)) ? 'active' : ((!selection.active) ? 'disable' : selection.change)">
								<span class="odd text-center">
										{{ selection.odd }}
										<br />
									</span>
								<span v-if="!selection.active || selection.odd === '1.00'">
									<i class="icon-lock"></i>
								</span>
							</a>
						</div>
					</div>
				</div>
			</template>
			<template v-if="odd.layout > 0">
				<div class="market-item market-header b-r">
					<div class="market-wrapper">
						{{odd.name}}
					</div>
					<a @click="resetMarket(odd.id)" href="javascript:;" class="btn btn-outline-primary pull-right">
						Reset
					</a>
				</div>
				<div class="market-item b-t b-r">
					<div class="odd-labels">
						<div v-for="selection in odd.odd" class="b-r b-b text-center">
							<router-link target="_blank" :to="{path: '/bet-logs', query: {odd: selection.id}}" :class="(findByKey(selectedOdds, 'oddId', selection.id)) ? 'active' : ((!selection.active) ? 'disable' : selection.change)">
                <span class="outcome px-2">{{ selection.outcome }}</span>
                <span class="odd px-2">{{ selection.odd }}</span>
								<span v-if="!selection.active || selection.odd === '1.00'">
									<i class="icon-lock"></i>
								</span>
							</router-link>
							<select v-on:change="regenerateBet(selection.id, selection.resultId)" class="form-control form-control-sm rounded w150 pull-right" v-model="selection.resultId" v-if="betStatus">
								<option :value="result.id" v-for="result in betStatus" >{{ result.name }}</option>
							</select>
						</div>
					</div>
				</div>
			</template>
		</div>
</div>
</template>

<script>
	import betStats from '@/components/stats/odds/betStats'
	import oddHeader from '@/components/stats/odds/oddHeader'
    import spinalLoader from '@/components/ui/loader/spinalLoader.vue'
	import betManager from '@/mixins/betmanager'

    export default {
        name: 'odd',
	      mixins: [betManager],
        components: {spinalLoader, oddHeader, betStats},
        data () {
            return {
                t: this.$root.t,
                oddHeader: false,
                odds: [],
                matchNotfound: false,
                loading: true,
                selectedOdds: [],
                match: null,
                betStatus: null,
                marketType: 0,
                re: 0,
                liveOdds: false
            }
        },
        props: {
            matchId: {
                default: 0,
            },
        },
        watch: {
            'liveOdds' () {
                this.subMatchOdds();
                this.fetchMatch();
            },
            'matchId' (n,o) {
                this.subMatchOdds();
                this.fetchMatch();

            },
            're' () {
                  this.subMatchOdds();
                  this.fetchMatch();
            }
        },
        destroyed () {

        },
        mounted () {

            this.fetchBetStatus().then(response => {
                this.betStatus = response.body
            })

            this.subMatchOdds();
            this.fetchMatch();

            var self = this;
            this.$bus.$on('addBet', ($event) => {

                self.selectedOdds = $event;

            })

            this.$bus.$on('updatedOdd', (payload) => {

                var odds = this.odds;

	            for (var o in odds)
	            {
	                for (var od in odds[o].odd)
	                {
	                    var odd = odds[o].odd[od];
	                    odd.change = (odd.change) ? odd.change : null;


	                    if (payload.id == odd.id) {
	                        odd.active = (payload.disable) ? 0 : 1;
	                        odd.change = (payload.o > payload.n) ? 'down' : 'up';

	                        odd.odd = parseFloat(payload.n).toFixed(2);

	                        //document.getElementById("demo");
	                    }
	                }
	            }
            })
        },
        methods: {

            filterMarket (Market) {
                this.marketType = Market;
            },
            checkFilteredMarket (marketType, markets) {
              if(marketType == 0){
                  return true;
              }else {

                if(markets.includes(this.marketType)) {
                  return true;
                }else {
                    return false;
                }
              }
            },
            subMatchOdds (m) {
                if (this.matchId) {
                    //this.odds = [];
                    this.loading = true;
                    var th = this;
                    if(this.live) {
                        //window.scrollTo(0, 150);
                    }

                    this.$http.get(bsapi+'api/v1/fixture/odds/'+th.matchId, {
                        params: {match: this.matchId, isLive: this.liveOdds},

                    }).then(response => {
                        // get body data
                        th.oddHeader = true;
                        th.odds = response.body.result.odds;

                        th.matchNotfound = false;
                        th.loading = false;

                    }, response => {
                        // error callback
                        th.oddHeader = false;
                        th.matchNotfound = true;
                        th.loading = false;
                        th.odds = null;

                    })

                }
            },
            fetchMatch () {
                //this.match = null;

                this.$http.get(bsapi+'api/v1/fixture/matches', {
                    params: {match: this.matchId, onLive: this.live},

                }).then(response => {
                    // get body data
                    var th = this;
	                var vats = Object.values(response.body.result.sport);

	                vats.forEach(function(entry) {
	                    Object.values(entry.region).forEach(function(reg) {
	                        Object.values(reg.competition).forEach(function(competition) {
	                            Object.values(competition.matches).forEach(function(match) {
	                                if (match.matchId == th.matchId) {
	                                    th.match = match;
	                                }

	                            });
	                        });
	                    });
	                });

                }, response => {
                    // error callback
                    this.match = null;

            })
            }
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.live-tracker {
		border: none;
		width: 100%;
		height: 45vh;
	}
	.odd-loading {
		width: 150px;
		min-height: 150px;
		margin: auto;
	}
	.market-item {
		display: flex;
		width: 100%;
		font-size: 11px;
	}

	.market-wrapper {
		flex: 0 0 75%;
		align-items: center;
		line-height: 23px;
		display: flex;
		overflow: hidden;
		white-space: normal;
		text-overflow: ellipsis;
		padding-left: 10px;
		box-sizing: border-box;
		min-height: 30px;
	}

	.odd-labels {
		width: 100%;
	}
	.odd-labels div {
		width: 33.3%;
		min-height: 30px;
		float: left;
		font-size: 11px;
		display: flex;
		text-align: left;
		justify-content: center; /* align horizontal */
		align-items: center;
	}

	.odd-labels a {
		float: left;
		width: 100%;
		height: 100%;
		display: flex;
		text-align: left;
		justify-content: center; /* align horizontal */
		align-items: center;
	}
	.odd-labels .active{
		background: #f9ab33 !important;
		color: #fff
	}

	.odd-labels .active .odd{
		color: #fff;
	}

	.market-item .odd-labels div {
	}

	.market-header {
		font-weight: bold;
		font-size: 14px;
	}

	.color-scheme-dark .market-item .odd-labels div {
		background-image: linear-gradient(180deg, #273048, #303950);
	}

	.odd-labels .odd, .odd-labels .outcome {
		float: right;
		width: 100%;
		display: block;

	}
	.odd-labels .odd {
		color: #f70;
		font-weight: bold;
		text-align: right;
	}
	.color-scheme-dark .odd-labels .odd {
	}

	.typcn-arrow-sorted-up {
		color: green;
	}
	.typcn-arrow-sorted-down {
		color: red;
	}

	.mandown {
		background: linear-gradient(45deg, rgba(255,0,4,1) 0%,rgba(255,23,27,1) 9%,rgba(255,26,30,0) 10%,rgba(255,255,255,0)) !important;
	}

	.manup {
		background: linear-gradient(45deg, rgba(255,255,255,0) 0%,rgba(25,181,59,0) 90%,rgba(23,180,57,1) 91%,rgba(0,173,37,1) 100%) !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/odds/odd.vue